export default "__VITE_ASSET__CsgCUe$R__"